import React from "react"

import "./index.css"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export const PartnersLogos = ({hasPartnerLogo, partnerLogo}) => {
    return (
        <>
            {(hasPartnerLogo !== null || partnerLogo !== null) && partnerLogo && (
                <div className={`flex justify-center handle-logo${(partnerLogo.borderLayout === null || partnerLogo.borderLayout === 'Default: Circle') ? ' circle' : ' rectangle'}${partnerLogo.hasBorder ? ' border--visible' : ' border--hidden'}`}>
                    <GatsbyImage
                        image={getImage(partnerLogo.image)}
                        alt="logo"
                    />
                </div>
            )}
        </>
    )
}